import { useMutation } from "@tanstack/react-query";
import { ReviewService } from "../../services/review.service";
import { ClassEventReservationService } from "../../services/class-event-reservation.service";

export const useClassEventReservationMutations = () => {
  const { mutate: cancel } = useMutation<
    any,
    Error,
    { reservationId: number; gymListingId: string }
  >({
    mutationFn: async ({ reservationId, gymListingId }) =>
      ClassEventReservationService.cancel(reservationId, gymListingId),
  });

  return {
    cancel,
  };
};
